import { useEffect, useState } from 'react';
// 1. ایمپورت api به جای axios
import api from './api';

export const useGet = (url, isRun = false) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isResult, setIsResult] = useState(false);


    useEffect(() => {
        // شرط اجرا: حتماً باید url وجود داشته باشد
        if (url) {
            const fetchData = async () => {
                setIsLoading(true);
                setError(null); // پاک کردن ارورهای قبلی قبل از درخواست جدید
                
                try {
                    // 3. استفاده از api.get (توکن خودکار ارسال می‌شود)
                    const response = await api.get(url);
                    
                    console.log("GetHook Url:", url);

                    // بررسی وضعیت (هرچند axios برای ارورها throw می‌کند)
                    if (response.status !== 200) {
                        throw new Error(response.statusText);
                    }

                    // فرض بر این است که دیتای اصلی داخل data.data است (طبق کد قبلی شما)
                    setData(response.data.data);
                    setIsResult(true);
                    // console.log("Get Hook Data:", response.data.data);

                } catch (err) {
                    // console.error("GetHook Error:", err);
                    
                    // تلاش برای استخراج پیام خطای دقیق از سمت سرور
                    const errorMsg = err.response?.data?.message || err.message;
                    setError(errorMsg);
                    setIsResult(false);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchData();
        }
    }, [url, isRun]);

    return { data, isLoading, error, isResult };
};
